<template>
	<div class="poreservey">
		<Loading msg="loading" v-if="!isload" />
		<div class="pore_survey_inner" v-else>
      		<img @click="$parent.goBack()"
				v-lazy="'https://static.inertiabiotech.com/uniskin/reportv3/images/gene_test_back.png'"
				class="back_btn lazy"
				alt="" />
                <h1 class="pore_survey_title">拯救毛孔粗大</h1>
       

   
		
		</div>

 
	</div>
</template>

<script>
import Loading from "./Loading.vue";
import axios from "axios";
var wx = require("weixin-js-sdk");
export default {
  name: "PoreSurvey",
  data() {
    return {
      isload: false,
      in_weapp: false, //是否在小程序
      poreservey_data:null,
      imgs: [
        require("../assets/images/1.png"),
        require("../assets/images/2.png"),
        require("../assets/images/3.png"),
        require("../assets/images/4.png")
      ],
      demopic: require("../assets/images/10.png")
    };
  },

  created() {
    console.log("poreservey created", this);
    this.initPoreServey();
  },
  mounted() {
    var ua = navigator.userAgent.toLowerCase(),
      that = this;
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      wx.miniProgram.getEnv(res => {
        if (res.miniprogram) {
          console.log("在小程序里");
          that.in_weapp = true;
        }
      });
    }
  },
  methods: {
    goMallDetail: function(pid) {
      if (this.in_weapp) {
        wx.miniProgram.navigateTo({
          url: "/mall-detail/mall-detail?scene=" + pid
        });
      } else {
        location.href =
          "https://www.uniskin.com.cn/homepage/m/pro_detail.html?p=" + pid;
      }
    },
    initPoreServey: function() {
      let that = this;
      var local_pore_survey = JSON.parse(localStorage.getItem("local_pore_survey"));
      if (local_pore_survey) {
        afterPoreServey(local_pore_survey);
      } else {
        that
          .$jsonp(
            "https://www.uniskin.com.cn/reportv2/index/gene_july_one/getSkinMethod"
          )
          .then(json => {
            console.log(json);
            afterPoreServey(json);
            // localStorage.setItem("local_pore_survey",JSON.stringify(json));
          })
          .catch(err => {
            console.log(err);
            localStorage.clear();
            location.href =
              "https://www.uniskin.com.cn/mall/member/account/login";
          });
      }
      function afterPoreServey(poreservey_data) {
        if (poreservey_data.code == 0) {
          that.isload = true;
          that.poreservey_data = poreservey_data.skin_method_info;


        }
      }
    },
    displayIng: function(ing) {
      this.show_ing = true;
      this.ing_obj = ing;
    },

    initActionLog: function(m, pageid) {
      if (m && pageid)
        return axios.get("/mall/member/reportV2/actionlog", {
          params: { m, pageid }
        });
    }
  },
  components: {
    Loading
  }
};
</script>
<style lang="less" scoped>
@import "../styles/mixin.less";
@import "../styles/reset.less";
.pore_survey_inner{
    background:@bg_c_m;
    padding:54/50rem 30/50rem 283/50rem;
}
.back_btn{
    position:fixed;
    top:0.6rem;
    left:0;
    width:2.36rem;
    height:1.08rem;
    z-index:888;
}
.pore_survey_title{
    padding-bottom:71/50rem;
    font-size:44/50rem;
    font-weight:bold;
    line-height:1em;
    text-align:center;
    color:@font-c-3;
}


</style>
